import React, { useEffect, useState } from "react";
import { Card, Grid, Button, Box, Typography, Snackbar, Slide, Alert } from "@mui/material";
import SoftBox from "components/SoftBox";
import logo from "assets/images/Anser.png";
import cartoonImage from "assets/images/Chat bot-bro.svg";
import successCartoon from "assets/images/Mailbox-bro.svg";
import doneCartoon from "assets/images/Completed steps-rafiki.svg";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import axios from "axios";
import { FAST_API_BASE_URL } from "constants";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const ConfirmPassword = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [formData, setFormData] = useState({
    password: "",
    confirmpassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [mismatchError, setMismatchError] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const passwordRules = {
      letter: /[A-Za-z]/.test(formData.password),      
      uppercase: /[A-Z]/.test(formData.password),     
      lowercase: /[a-z]/.test(formData.password),      
      number: /[0-9]/.test(formData.password),        
      specialChar: /[^A-Za-z0-9]/.test(formData.password),
      minLength: formData.password.length >= 8,       
        
      };

   

  const allRulesPassed = Object.values(passwordRules).every(Boolean);
  useEffect(() => {
    
    const secret = queryParams.get("secret");

  
    if (secret) {
      sessionStorage.setItem("secret", secret);
    } else {
      sessionStorage.clear();
    }
  }, [location.search]);
  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === "confirmpassword") {
      setMismatchError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.password || !formData.confirmpassword) {
      alert("Please fill in both password fields");
      return;
    }

    if (formData.password !== formData.confirmpassword) {
      setMismatchError("Passwords do not match!");
      return;
    }

    if (!allRulesPassed) {
      alert("Password does not meet the required criteria");
      return;
    }

    setLoading(true);
    try {
      const payload = { password: formData.password };

      const response = await axios.patch(
        `${FAST_API_BASE_URL}/api/update-password`,
        payload,
        {
          headers: {
            "SECRET-TOKEN": sessionStorage.getItem("secret"),
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Password saved:", response.data);
                setSnackbarMessage("Password updated successfully! Please wait...");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
      setSuccess(true);
      navigate("/login");
    } catch (err) {
      console.error("Password save failed:", err);
        setSnackbarMessage("Failed to create account! Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const renderRule = (label, passed) => (
    <Box display="flex" alignItems="center" mb={1}>
      {passed ? (
        <CheckCircleIcon   sx={{ mr: 1,color:"#219297",fontSize:"12px" }} />
      ) : (
        <CancelIcon color="error" fontSize="small" sx={{ mr: 1 }} />
      )}
    <Typography variant="body2" color={passed ? "#219297" : "text.secondary"} sx={{fontSize:"12px"}}>
        {label}
      </Typography>
    </Box>
  );

  return (
    <>
      <SoftBox px={2} py={1} width="100%" bgColor="white" shadow="md">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <img src={logo} alt="Ansera Logo" style={{ height: "4rem" }} />
        </Box>
      </SoftBox>
       <Snackbar
              open={snackbarOpen}
              autoHideDuration={4000}
              onClose={() => setSnackbarOpen(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              TransitionComponent={(props) => <Slide {...props} direction="top" />}
            >
              <Alert
                onClose={() => setSnackbarOpen(false)}
                severity={snackbarSeverity}
                variant="filled"
                sx={{
                  width: "100%",
                  color: "#fff",
                  backgroundColor:
                    snackbarSeverity === "success"
                      ? "#008080"
                      : snackbarSeverity === "error"
                      ? "#d32f2f"
                      : undefined,
                }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>

      <SoftBox
        height="calc(100vh - 5rem)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgColor="#f0f4f7"
        px={2}
      >
        <Grid container spacing={4} alignItems="center" justifyContent="center" maxWidth="lg">
          {!isMobile && (
            <Grid item md={6}>
              <Box
                component="img"
                src={success ? doneCartoon : cartoonImage}
                alt="Illustration"
                sx={{ width: "100%", maxWidth: "500px", mx: "auto" }}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={10} md={6}>
            <Card
              sx={{
                padding: 4,
                maxWidth: 480,
                margin: "0 auto",
                boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                borderRadius: 4,
              }}
            >
              {success ? (
                <Box textAlign="center">
                  <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Password Saved 🎉
                  </Typography>
                  <Typography variant="body1" color="text.secondary" mb={3}>
                    Your password has been set successfully.
                  </Typography>
                  <Box
                    component="img"
                    src={successCartoon}
                    alt="Success"
                    sx={{ width: "100%", maxWidth: "300px", mx: "auto", mt: 2 }}
                  />
                </Box>
              ) : (
                <Grid container direction="column" spacing={3}>
                  <Grid item>
                    <Typography
                      variant="h3"
                      fontWeight="bold"
                      color="text.primary"
                      align="center"
                    >
                      Set Your Password
                    </Typography>
                    <Typography variant="body1" color="text.secondary" align="center" mt={1}>
                      Enter and confirm your password
                    </Typography>
                  </Grid>

                  <Grid item>
                    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                      <div style={{ marginBottom: "20px" }}>
                        <label htmlFor="password" style={{ display: "block", marginBottom: "6px" }}>
                          Password
                        </label>
                        <input
                          id="password"
                          name="password"
                          type="password"
                          value={formData.password}
                          onChange={handleChange}
                          placeholder="Enter password"
                          required
                          style={{
                            width: "100%",
                            padding: "12px 14px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                          }}
                        />

                        {formData.password && (
                            <Box mt={2}>
                          {renderRule("At least 8 characters", passwordRules.minLength)}
                          {renderRule("Includes a number", passwordRules.number)}
                          {renderRule("Includes a special character", passwordRules.specialChar)}
                          {renderRule("Includes Uppercase[A-Z]", passwordRules.uppercase)}
                          {renderRule("Includes Lowercase[a-z]", passwordRules.lowercase)}
                        </Box>
                        )}
                        
                      </div>

                      <div style={{ marginBottom: "20px" }}>
                        <label
                          htmlFor="confirmpassword"
                          style={{ display: "block", marginBottom: "6px" }}
                        >
                          Confirm Password
                        </label>
                        <input
                          id="confirmpassword"
                          name="confirmpassword"
                          type="password"
                          value={formData.confirmpassword}
                          onChange={handleChange}
                          placeholder="Re-enter password"
                          required
                          style={{
                            width: "100%",
                            padding: "12px 14px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                          }}
                        />
                        {mismatchError && (
                          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                            {mismatchError}
                          </Typography>
                        )}
                      </div>

                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={loading || !allRulesPassed}
                        sx={{
                          padding: "10px 0",
                          borderRadius: "8px",
                          backgroundColor: allRulesPassed ? "#219297" : "#ccc",
                          color: "#ffffff",
                        }}
                      >
                        {loading ? "Saving..." : "Save Password"}
                      </Button>
                    </form>
                  </Grid>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
    </>
  );
};

export default ConfirmPassword;
